// extracted by mini-css-extract-plugin
export default {"error":"ErrorValue_error__YVAxJ","icon":"ErrorValue_icon__jGoiR"};